import { useState, useEffect } from 'react';
import Styles from './PasswordStrength.module.scss'
import { passwordStrength } from 'check-password-strength'

export function PasswordStrength({ data, nextDisabled }) {
    const [strength, setStrength] = useState('')
    const password_icon = "https://cdn-icons-png.flaticon.com/512/7939/7939105.png";

    useEffect(() => {
        if (strength === "Strong") {
            nextDisabled();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [strength])

    function onPasswordChange(e) {

        setStrength(passwordStrength(e.target.value).value);
    }
    function setColor() {
        let color;
        switch (strength) {
            case 'Too weak':
                color = 'red';
                break;
            case "Weak":
                color = '#ef9b0f';
                break;
            case 'Medium':
                color = '#ffff00';
                break;
            case 'Strong':
                color = "darkgreen";
                break;
            default:
                color = "black";
                break;
        }

        return color
    }
    return (
        <div className={Styles.mainContainer}>
            <div className={`${Styles.contentContainer} ${Styles.inputContainer}`} >
                <img src={password_icon} width="25%" alt='passwordIcon' />
                <p className={Styles.heading}>TYPE A PASSWORD</p>
                <input type='text' placeholder='Enter Password' onChange={onPasswordChange} className={Styles.passwordInput} />
                {strength !== '' &&
                    <p className={Styles.strength}>
                        Password strength:
                        <span
                            style={{
                                color: setColor()
                            }}
                        >
                            {strength}
                        </span>
                    </p>
                }
            </div>
            <div className={`${Styles.contentContainer} ${Styles.instructionsContainer}`}>
                <p>{data?.instructions}</p>
            </div>
        </div>
    )
}
